import { IRoute } from "@src/routes";
import CreateDiscountRulePage from "./pages/CreateDiscountRulePage";
import EditDiscountRulePage from "./pages/EditDiscountRulePage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/pbm/programs/:programCode/families/:programFamilyCode/discount-rules/new",
    key: "DISCOUNT_RULE_NEW",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: CreateDiscountRulePage,
  },
  {
    path: "/pbm/programs/:programCode/families/:programFamilyCode/discount-rules/:discountRuleId/edit",
    key: "DISCOUNT_RULE_EDIT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: EditDiscountRulePage,
  },
];

export default routes;
